<template>
	<icon-svg
		class="close-popup-btn"
		icon="ic_close"
		:fill="color"
		@click="handleClose"
	/>
</template>

<script>
import IconSvg from '@/components/IconSvg.vue'

export default {
	name: 'CloseBtn',

	components: { IconSvg },

	props: {
		color: {
			type: String,
			default: ''
		}
	},

	methods: {
		handleClose() {
			this.$emit('close')
		}
	}
}
</script>

<style scoped lang="scss">
.close-popup-btn {
	position: absolute;
	top: 0;
	left: 0;
	cursor: pointer;
}
</style>
